import { render, staticRenderFns } from "./Customized.vue?vue&type=template&id=7aeb5455&scoped=true"
import script from "./Customized.vue?vue&type=script&lang=js"
export * from "./Customized.vue?vue&type=script&lang=js"
import style0 from "./Customized.vue?vue&type=style&index=0&id=7aeb5455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aeb5455",
  null
  
)

export default component.exports